/**
 *
 * @param organizationUserId
 */
export const getOrgUserPath = (organizationUserId: string): string => {
  return `/user/${organizationUserId}`
}
